import { createRoot } from 'react-dom/client';
import { App } from './app';
import { appStarted } from './init';

appStarted();

createRoot(document.getElementById('root')!).render(<App />);
